export { default } from "./OrderDetail";

